import { render } from "./screen-shots.vue?vue&type=template&id=4da02aaf&scoped=true"
import script from "./screen-shots.vue?vue&type=script&lang=js"
export * from "./screen-shots.vue?vue&type=script&lang=js"

import "./screen-shots.vue?vue&type=style&index=0&id=4da02aaf&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da02aaf"]])

export default __exports__